import { render, staticRenderFns } from "./detail.html?vue&type=template&id=062b5a07&scoped=true&external"
import script from "./detail.js?vue&type=script&lang=js&external"
export * from "./detail.js?vue&type=script&lang=js&external"
import style0 from "./detail.scss?vue&type=style&index=0&id=062b5a07&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "062b5a07",
  null
  
)

export default component.exports